export default function HeartOutlineIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
        <path d="M14.7279 1.03164C10.4979 0.611641 9.79788 4.50164 9.70788 5.07164H9.68788C9.60788 4.50164 8.90788 0.611641 4.67788 1.03164C0.827883 1.41164 -0.202117 6.23164 2.55788 9.18164C4.59788 11.3516 9.70788 16.4616 9.70788 16.4616C9.70788 16.4616 14.8179 11.3616 16.8579 9.18164C19.6179 6.24164 18.5779 1.42164 14.7279 1.03164Z" stroke="#1E3665" strokeWidth="1.5" strokeMiterlimit="10"/>
    </svg>
  );
}
